var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13954",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72380",
    d: "M26.3 30a1.3 1.3 0 0 0-1.3 1.3v12.9a1.3 1.3 0 0 0 1.3 1.3H36l2.805 2.794A.7.7 0 0 0 40 47.8v-2.3h2.7a1.3 1.3 0 0 0 1.3-1.3V31.3a1.3 1.3 0 0 0-1.3-1.3zm8.715 3.314 1.039 2.062a.573.573 0 0 0 .432.307l2.322.331a.559.559 0 0 1 .318.959l-1.681 1.6a.56.56 0 0 0-.145.229.552.552 0 0 0-.02.269l.4 2.266a.572.572 0 0 1-.832.593l-2.078-1.07a.584.584 0 0 0-.534 0l-2.077 1.07a.572.572 0 0 1-.833-.593l.4-2.266a.552.552 0 0 0-.02-.269.562.562 0 0 0-.145-.229l-1.681-1.6a.559.559 0 0 1 .318-.959l2.322-.331a.574.574 0 0 0 .433-.307l1.038-2.062a.58.58 0 0 1 1.03 0",
    transform: "translate(-22.5 -26.5)",
    style: {
      fill: "current",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReview);
export default __webpack_public_path__ + "static/media/ic_review.833eae0767787c4e3774875d9df4ce20.svg";
export { ForwardRef as ReactComponent };